import React, { useState } from "react";
import { accountService } from "../services/accountService";
import { Button, Form, FormGroup, Input } from "reactstrap";
import Warning from "./Warning";

const ForgotPassword = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [invalid, setInvalid] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [email, setEmail] = useState<string>();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setInvalid(false);
    if (email) {
      try {
        await accountService.forgotPassword(email);
        setSuccess(true);
        setIsSubmitting(false);
      } catch (error) {
        setIsSubmitting(false);
        setInvalid(true);
      }
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      className="shadow-box"
      style={{ width: 400, maxWidth: "100%", margin: "auto" }}
    >
      <h2>
        <b>Resetowanie hasła</b>
      </h2>
      <hr />
      <div style={{ textAlign: "justify" }}>
        Wpisz swój adres e-mail, który był przez Ciebie użyty do rejestracji.
        Wyślemy do Ciebie wiadomość e-mail z Twoją nazwą użytkownika oraz
        linkiem umożliwiającym zresetowanie hasła.
      </div>
      <FormGroup style={{ marginTop: 15, marginBottom: 10 }}>
        <Input
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          type="email"
          name="email"
          id="email"
          required
        />
      </FormGroup>
      {invalid && <Warning>Błąd! Spróbuj ponownie</Warning>}
      {isSubmitting ? (
        <div className="spinner" />
      ) : (
        <Button style={{ marginBottom: 20 }} disabled={isSubmitting}>
          Wyślij
        </Button>
      )}
      {success && (
        <p>
          Wiadomość została wysłana. Sprawdź swoją skrzynkę pocztową, a w razie
          problemów sprawdź czy wiadomość nie wylądowała w spamie.
        </p>
      )}
      <p>
        Jeśli nadal potrzebujesz pomocy, napisz na adres email
        checkardicosmetics@gmail.com
      </p>
    </Form>
  );
};

export default ForgotPassword;
